import slugs from '../resources/slugs';
import LoginComponent from '../views/Auth/Login';
import DashboardComponent from '../views/dashboard';
import ContentManagement from '../views/ContentManagement';
import ForgotPasswordComponent from '../views/Auth/ForgotPassword';
import ResetPasswordComponent from '../views/Auth/ResetPassword';

const privateRouteList = [
  { id: 1, path: slugs.dashboard, component: <DashboardComponent /> },
  { id: 2, path: slugs.cms_home, component: <ContentManagement section="home" /> },
  { id: 3, path: slugs.cms_banking, component: <ContentManagement section="banking" /> },
  { id: 4, path: slugs.cms_faqs, component: <ContentManagement section="faqs" /> },
  { id: 5, path: slugs.cms_testimonials, component: <ContentManagement section="testimonials" /> },
  { id: 6, path: slugs.cms_ecosystem, component: <ContentManagement section="ecosystem" /> },
  { id: 7, path: slugs.cms_blogs, component: <ContentManagement section="blogs" /> },
  { id: 8, path: slugs.cms_partners, component: <ContentManagement section="partners" /> },
  { id: 9, path: slugs.cms_advantages, component: <ContentManagement section="advantages" /> },
  { id: 10, path: slugs.cms_how_it_works, component: <ContentManagement section="how_it_works" /> },
  { id: 11, path: slugs.cms_features, component: <ContentManagement section="features" /> },
  { id: 12, path: slugs.cms_about, component: <ContentManagement section="about" /> },
  { id: 13, path: slugs.cms_cta_sections, component: <ContentManagement section="cta_sections" /> },
  { id: 14, path: slugs.cms_settings, component: <ContentManagement section="settings" /> },
  { id: 15, path: slugs.cms_admins, component: <ContentManagement section="admins" /> },
];

const publicRouteList = [
  { id: 1, path: slugs.login, component: <LoginComponent /> },
  { id: 2, path: slugs.forgotPassword, component: <ForgotPasswordComponent /> },
  { id: 3, path: slugs.changePasswordFromEmail, component: <ResetPasswordComponent /> },
];

export { privateRouteList, publicRouteList };
